import { FC, CSSProperties } from 'react';

type ClearAllIconProps = {
  style?: CSSProperties;
  className?: string;
};

const ClearAllIcon: FC<ClearAllIconProps> = ({ style, className }) => {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={ style }
      className={ className }
    >
      <path
        // eslint-disable-next-line max-len
        d="M9.25 13.75C10.5356 13.75 11.7923 13.3688 12.8612 12.6546C13.9301 11.9403 14.7632 10.9252 15.2552 9.73745C15.7472 8.54973 15.8759 7.24279 15.6251 5.98192C15.3743 4.72104 14.7552 3.56285 13.8462 2.65381C12.9372 1.74477 11.779 1.1257 10.5181 0.874899C9.25721 0.624095 7.95028 0.752816 6.76256 1.24479C5.57484 1.73676 4.55968 2.56988 3.84545 3.6388C3.13122 4.70772 2.75 5.96442 2.75 7.25V7.75M0.75 5.748L2.75 7.748L4.75 5.748"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClearAllIcon;
